import React, { useState, useRef } from 'react';
import { Dialog } from './dialog';
import { Text } from './text';
import { Button } from './button';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// Field definitions (copy from ProcessFiles)
const ACTA_FIELDS = [
  { name: 'Razón Social', value: 'CompanyName' },
  { name: 'Fecha de Constitución', value: 'DateOfCompanyConstitution' },
  { name: 'Poderes Administrativos', value: 'AdministrationPower' },
  { name: 'Poderes de Dominio', value: 'DomainPowers' },
  { name: 'Ambos Poderes', value: 'BothPowers' },
  { name: 'Accionistas', value: 'ListOfShareholders' },
  { name: '% Accionistas', value: 'ShareholderStock' },
  { name: 'Exclusion de Extranjeros', value: 'ForigenersExclusionClause' },
];
const ACTA_ASAMBLEA_FIELDS = [
  { name: 'Razón Social', value: 'CompanyName' },
  { name: 'Fecha de Constitución', value: 'DateOfCompanyConstitution' },
  { name: 'Poderes Administrativos', value: 'AdministrationPower' },
  { name: 'Poderes de Dominio', value: 'DomainPowers' },
  { name: 'Ambos Poderes', value: 'BothPowers' },
  { name: 'Accionistas', value: 'ListOfShareholders' },
  { name: '% Accionistas', value: 'ShareholderStock' },
  { name: 'Exclusion de Extranjeros', value: 'ForigenersExclusionClause' },
  { name: 'Fecha de Notarización', value: 'NotarizationDate' },
];
const CSF_FIELDS = [
  { name: 'RFC', value: 'RFC' },
  { name: 'Nombre Legal de la Compañía', value: 'CompanyLegalName' },
  { name: 'Régimen Capital', value: 'CapitalRegime' },
  { name: 'Régimen Fiscal', value: 'TaxRegime' },
  { name: 'Domicilio Fiscal', value: 'FiscalAddress' },
  { name: 'Código Postal', value: 'PostalCode' },
  { name: 'Actividad Económica', value: 'EconomicActivity' },
  { name: 'Fecha de Inscripción', value: 'RegistrationDate' },
  { name: 'Status', value: 'Status' },
];
const COMPROBANTE_FIELDS = [
  { name: 'Nombre de la Compañía', value: 'CompanyName' },
  { name: 'Dirección de Servicio', value: 'ServiceAddress' },
  { name: 'Código Postal', value: 'PostalCode' },
  { name: 'Tipo de Documento', value: 'DocumentType' },
  { name: 'Fecha del Documento', value: 'DocumentDate' },
];
const IDENTIFICACION_FIELDS = [
  { name: 'Tipo de Documento', value: 'DocumentType' },
  { name: 'Nombre Completo', value: 'FullName' },
  { name: 'Fecha de Vencimiento', value: 'ExpirationDate' },
  { name: 'Número de Documento', value: 'DocumentNumber' },
  { name: 'Es Válido', value: 'IsValid' },
];
const ACUSE_FIELDS = [
  { name: 'Fecha de Presentación', value: 'PresentationDate' },
  { name: 'Folio de Recepción', value: 'ReceiptNumber' },
  { name: 'RFC', value: 'RFC' },
  { name: 'Razón Social', value: 'CompanyName' },
  { name: 'Tipo de Declaración', value: 'DeclarationType' },
  { name: 'Ejercicio Fiscal', value: 'FiscalYear' },
];
const DECLARACION_FIELDS = [
  { name: 'RFC', value: 'RFC' },
  { name: 'Razón Social', value: 'CompanyName' },
  { name: 'Ejercicio Fiscal', value: 'FiscalYear' },
  { name: 'Ingresos Totales', value: 'TotalIncome' },
  { name: 'Utilidad Fiscal', value: 'TaxableIncome' },
  { name: 'Impuesto Causado', value: 'TaxDue' },
  { name: 'Impuesto a Cargo', value: 'TaxPayable' },
];

const CONTRATO_FIELDS = [
  { name: 'Título del Contrato', value: 'tituloContrato' },
  { name: 'Tipo de Contrato', value: 'tipoContrato' },
  { name: 'Descripción', value: 'descripcion' },
  { name: 'Contratante', value: 'contratante' },
  { name: 'Monto del Contrato', value: 'montoContrato' },
  { name: 'Fecha de Inicio', value: 'fechaInicio' }, 
  { name: 'Fecha de Término', value: 'fechaTermino' },
  { name: 'Fianzas Requeridas', value: 'fianzasRequeridas' },
];


const ESTADOS_FINANCIEROS_CONTADOR_FIELDS = [
  { name: 'Total Activo', value: 'totalActivo' },
  { name: 'Activo Circulante', value: 'activoCirculante' },
  { name: 'Inventarios', value: 'inventarios' },
  { name: 'Cuentas por Cobrar', value: 'cuentasPorCobrar' },
  { name: 'Total Pasivo', value: 'totalPasivo' },
  { name: 'Pasivo Circulante', value: 'pasivoCirculante' },
  { name: 'Cuentas por Pagar', value: 'cuentasPorPagar' },
  { name: 'Total Capital Contable', value: 'totalCapitalContable' },
  { name: 'Total Ingresos', value: 'totalIngresos' },
  { name: 'Costo de Ventas', value: 'costoDeVentas' },
  { name: 'Total Gastos', value: 'totalGastos' },
  { name: 'Total Utilidad Antes de Impuestos', value: 'totalUtilidadAntesImpuestos' },
  { name: 'Total Utilidad Neta', value: 'totalUtilidadNeta' },
  { name: 'Año Fiscal', value: 'fiscalYear' },
  { name: 'Firma del Contador', value: 'hasAccountantSignature' },
  { name: 'Cédula Profesional del Contador', value: 'hasContadorCedulaProfesional' },
  { name: 'Texto de Responsabilidad del Contador', value: 'hasAccountantResponsabilityText' },
];

const ESTADOS_FINANCIEROS_PARCIALES_FIELDS = [
  { name: 'Periodo (Inicio)', value: 'periodoInicio' },
  { name: 'Periodo (Fin)', value: 'periodoFin' },
  ...ESTADOS_FINANCIEROS_CONTADOR_FIELDS,
];

const CEDULA_CONTADOR_FIELDS = [
  { name: 'Nombre Completo', value: 'NombreCompleto' },
  { name: 'Número de Cédula', value: 'NumeroCedula' },
  { name: 'Carrera o Título', value: 'CarreraOTitulo' },
  { name: 'Institución', value: 'Institucion' },
  { name: 'Fecha de Expedición', value: 'FechaExpedicion' },
  { name: 'Lugar de Expedición', value: 'LugarExpedicion' },
  { name: 'Tipo de Documento', value: 'TipoDocumento' },
  { name: 'URL de Verificación', value: 'URLVerificacion' },
];

const CURRICULUM_EMPRESARIAL_FIELDS = [
  { name: 'Nombre de la Empresa', value: 'NombreEmpresa' },
  { name: 'Resumen', value: 'Resumen' },
  { name: 'Servicios Principales', value: 'ServiciosPrincipales' },
  { name: 'Experiencia Destacada', value: 'ExperienciaDestacada' },
  { name: 'Equipo Clave', value: 'EquipoClave' },
  { name: 'Años de Experiencia', value: 'AniosExperiencia' },
  { name: 'Ubicación', value: 'Ubicacion' },
];

export function ProcessedFileDialog({
  open,
  onClose,
  processedFileData, // { analysis: { data, lines }, ... }
  fileType, // e.g. 'actaConstitutiva', 'constanciaSituacionFiscal', etc.
  fileName,
  fileLabel,
  pdfUrl,
  linkId,
  onMarkAsReviewed,
  onUnmarkAsReviewed,
  onRefresh,
}) {
  const [numPages, setNumPages] = useState(null);
  const [selectedLines, setSelectedLines] = useState([]);
  const [fieldIndices, setFieldIndices] = useState({});
  const pdfContainerRef = useRef(null);



  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Helper to render a field with clickable navigation for its sources
  const renderField = (label, fieldData, fieldKey) => {
    const fieldValue = fieldData?.[fieldKey];
    const sources = fieldValue?.sources || [];
    const currentIndex = fieldIndices[fieldKey] ?? 0;
    if (fieldKey === 'fianzasRequeridas') {
      const fianzasArr = fieldData?.[fieldKey]?.value || [];
      if (!Array.isArray(fianzasArr) || fianzasArr.length === 0) {
        return <div><span className="font-semibold">{label}:</span> No hay fianzas requeridas.</div>;
      }
      return (
        <div className="mb-4">
          <span className="font-semibold">{label}:
            {sources.length > 0 && (
              <span className="ml-1">
                {sources.length > 1 ? (
                  <>
                    <span
                      onClick={() => handleSourceNavigation(fieldKey, 'prev', sources)}
                      className="cursor-pointer text-blue-500 ml-2"
                      title="Anterior"
                    >
                      {'<'}
                    </span>
                    <span className="mx-1">
                      {currentIndex + 1}/{sources.length}
                    </span>
                    <span
                      onClick={() => handleSourceNavigation(fieldKey, 'next', sources)}
                      className="cursor-pointer text-blue-500"
                      title="Siguiente"
                    >
                      {'>'}
                    </span>
                  </>
                ) : (
                  <span
                    onClick={() => scrollToLines(sources)}
                    className="cursor-pointer text-blue-500 ml-2"
                    title="Ir al texto en el PDF"
                  >
                    •
                  </span>
                )}
              </span>
            )}
          </span>
          <table className="min-w-full text-xs border mt-2">
            <thead>
              <tr>
                <th className="px-2 py-1 border">Tipo</th>
                <th className="px-2 py-1 border">Porcentaje</th>
                <th className="px-2 py-1 border">Monto</th>
                <th className="px-2 py-1 border">Estatus</th>
                <th className="px-2 py-1 border">Pagada</th>
              </tr>
            </thead>
            <tbody>
              {fianzasArr.map((f, idx) => (
                <tr key={idx}>
                  <td className="px-2 py-1 border">{f.tipo}</td>
                  <td className="px-2 py-1 border">{f.porcentaje}%</td>
                  <td className="px-2 py-1 border">{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(f.monto)}</td>
                  <td className="px-2 py-1 border">{f.estatus}</td>
                  <td className="px-2 py-1 border">{f.pagada ? 'Sí' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    return (
      <div className="mb-4">
        <h3 className="font-semibold">
          {label}
          {sources.length > 0 && (
            <span className="ml-1">
              {sources.length > 1 ? (
                <>
                  <span
                    onClick={() => handleSourceNavigation(fieldKey, 'prev', sources)}
                    className="cursor-pointer text-blue-500 ml-2"
                    title="Anterior"
                  >
                    {'<'}
                  </span>
                  <span className="mx-1">
                    {currentIndex + 1}/{sources.length}
                  </span>
                  <span
                    onClick={() => handleSourceNavigation(fieldKey, 'next', sources)}
                    className="cursor-pointer text-blue-500"
                    title="Siguiente"
                  >
                    {'>'}
                  </span>
                </>
              ) : (
                <span
                  onClick={() => scrollToLines(sources)}
                  className="cursor-pointer text-blue-500 ml-2"
                  title="Ir al texto en el PDF"
                >
                  •
                </span>
              )}
            </span>
          )}
        </h3>
        <p>
          {Array.isArray(fieldValue?.value)
            ? fieldValue.value.map((item, index) => (
                <span key={index}>
                  {`- ${item}`}
                  <br />
                </span>
              ))
            : fieldValue?.value || 'N/A'}
        </p>
      </div>
    );
  };

  // Navegación entre fuentes
  const handleSourceNavigation = (fieldKey, direction, sources) => {
    setFieldIndices((prev) => {
      if (prev[fieldKey] === undefined) {
        scrollToLines([sources[0]]);
        return { ...prev, [fieldKey]: 0 };
      }
      const currentIndex = prev[fieldKey];
      let newIndex;
      if (direction === 'prev') {
        newIndex = currentIndex === 0 ? sources.length - 1 : currentIndex - 1;
      } else {
        newIndex = currentIndex === sources.length - 1 ? 0 : currentIndex + 1;
      }
      scrollToLines([sources[newIndex]]);
      return { ...prev, [fieldKey]: newIndex };
    });
  };

  // Scroll a líneas resaltadas
  const scrollToLines = (lineIds) => {
    if (lineIds && lineIds.length > 0 && pdfContainerRef.current) {
      const firstLineEl = document.getElementById(`highlight-${lineIds[0]}`);
      if (firstLineEl) {
        firstLineEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
      setSelectedLines(lineIds);
    }
  };

  // Render extracted data fields by type
  const renderFieldsByType = () => {
    if (!processedFileData?.results) return <Text>No hay datos extraídos.</Text>;
    if (fileType === 'constanciaSituacionFiscal') {
      return CSF_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'contrato') {
      return CONTRATO_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'actaConstitutiva') {
      return ACTA_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'comprobanteDomicilio') {
      return COMPROBANTE_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'identificacionOficial') {
      return IDENTIFICACION_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'actasAsambleas') {
      return ACTA_ASAMBLEA_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'acuseReciboDeclaracion') {
      return ACUSE_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'declaracionEjercicio') {
      return DECLARACION_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'estadosFinancieros') {
      return ESTADOS_FINANCIEROS_CONTADOR_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'estadosFinancierosParciales') {
      return ESTADOS_FINANCIEROS_PARCIALES_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'estadosFinancierosExcel') {
      // Excel: show raw data and summary tables
      return (
        <div className="space-y-6">
          {/* Raw Data Section */}
          {processedFileData?.results?.sheetData && Object.entries(processedFileData.results.sheetData).length > 0 && (
            <div className="border rounded-lg p-4">
              <Text className="font-medium text-lg mb-4">Datos del Excel</Text>
              <div className="space-y-4">
                {Object.entries(processedFileData.results.sheetData).map(([sheetName, rows]) => (
                  <div key={sheetName} className="border rounded-lg p-4">
                    <Text className="font-medium mb-4">{sheetName}</Text>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        {Array.isArray(rows) && rows.length > 0 && (
                          <>
                            <thead>
                              <tr className="bg-gray-50">
                                {Object.keys(rows[0]).map((header) => (
                                  <th
                                    key={header}
                                    className="px-4 py-2 text-left text-sm font-medium text-gray-900"
                                    style={{ minWidth: '150px' }}
                                  >
                                    {header}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                              {rows.map((row, rowIndex) => (
                                <tr key={rowIndex} className="hover:bg-gray-50">
                                  {Object.entries(row).map(([key, value], cellIndex) => (
                                    <td
                                      key={`${rowIndex}-${cellIndex}`}
                                      className="px-4 py-2 text-sm text-gray-900"
                                    >
                                      {typeof value === 'object'
                                        ? value === null
                                          ? ''
                                          : JSON.stringify(value)
                                        : value ?? ''}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </>
                        )}
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Balance General */}
          <div className="border rounded-lg p-4">
            <Text className="font-medium text-lg mb-4">Balance General</Text>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-900" style={{ minWidth: '300px' }}>Concepto</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-900" style={{ minWidth: '200px' }}>2023</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-900" style={{ minWidth: '200px' }}>2022</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {Object.entries(processedFileData?.results?.financial_summary?.balance_general || {}).map(([key, value]) => (
                    <tr key={key} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-900 font-medium capitalize">
                        {key.split('_').join(' ')}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right">
                        {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value['2023'] || 0)}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right">
                        {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value['2022'] || 0)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Estado de Resultados */}
          <div className="border rounded-lg p-4">
            <Text className="font-medium text-lg mb-4">Estado de Resultados</Text>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-900" style={{ minWidth: '300px' }}>Concepto</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-900" style={{ minWidth: '200px' }}>2023</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-900" style={{ minWidth: '200px' }}>2022</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {Object.entries(processedFileData?.results?.financial_summary?.estado_resultados || {}).map(([key, value]) => (
                    <tr key={key} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-900 font-medium capitalize">
                        {key.split('_').join(' ')}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right">
                        {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value['2023'] || 0)}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right">
                        {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value['2022'] || 0)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Conciliación Fiscal */}
          <div className="border rounded-lg p-4">
            <Text className="font-medium text-lg mb-4">Conciliación Fiscal</Text>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-900" style={{ minWidth: '300px' }}>Concepto</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-900" style={{ minWidth: '200px' }}>2023</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-900" style={{ minWidth: '200px' }}>2022</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {Object.entries(processedFileData?.results?.financial_summary?.conciliacion_fiscal || {}).map(([key, value]) => (
                    <tr key={key} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-900 font-medium capitalize">
                        {key.split('_').join(' ')}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right">
                        {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value['2023'] || 0)}
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-900 text-right">
                        {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value['2022'] || 0)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    } else if (fileType === 'cedulaContador') {
      return CEDULA_CONTADOR_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    } else if (fileType === 'curriculumEmpresarial') {
      return CURRICULUM_EMPRESARIAL_FIELDS.map((campo) => (
        <React.Fragment key={campo.value}>
          {renderField(campo.name, processedFileData.results, campo.value)}
        </React.Fragment>
      ));
    }
    return <Text>No hay campos configurados para este tipo de documento.</Text>;
  };

  return (
    <Dialog open={open} onClose={onClose} size="5xl" className="max-w-screen-2xl">
      <div className="flex flex-col lg:flex-row gap-6 min-w-0">
        {/* Panel de datos extraídos */}
        <div className="w-full lg:w-2/6 border rounded-lg p-4 bg-white overflow-y-auto max-h-[80vh] min-w-0">
          <Text className="font-medium mb-4">Datos Extraídos</Text>
          <div className="space-y-4">{renderFieldsByType()}</div>
        </div>
        {/* Panel de vista previa PDF */}
        {fileType !== 'estadosFinancierosExcel' && (
          <div className="w-full lg:w-4/6 border rounded-lg p-4 bg-white flex-shrink-0 min-w-0 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-2">
              <Text className="font-medium">Vista Previa</Text>
            </div>
            <div
              ref={pdfContainerRef}
              className="relative w-full border rounded flex-1 overflow-x-auto overflow-y-auto bg-gray-50 min-w-0"
            >
              {pdfUrl ? (
                <Document
                  file={pdfUrl}
                  onLoadSuccess={onDocumentLoadSuccess}
                  className="flex flex-col items-center"
                >
                  {Array.from(new Array(numPages), (el, index) => {
                    const pageNumber = index + 1;
                    const highlights = processedFileData && processedFileData.lines
                      ? Object.entries(processedFileData.lines).filter(([, line]) => Number(line.page) === pageNumber)
                      : [];
                    return (
                      <div key={pageNumber} className="relative mb-4">
                        <Page pageNumber={pageNumber}/>
                        {highlights.map(([id, line]) => {
                          const padding = 0.006;
                          return (
                            <div
                              id={`highlight-${id}`}
                              key={id}
                              style={{
                                position: 'absolute',
                                border: selectedLines.includes(id)
                                  ? '1px solid green'
                                  : '1px solid orange',
                                backgroundColor: selectedLines.includes(id)
                                  ? 'rgba(0, 255, 0, 0.3)'
                                  : 'rgba(255, 255, 0, 0.15)',
                                left: `${Math.max(0, line.boundingBox.left - padding) * 100}%`,
                                top: `${Math.max(0, line.boundingBox.top - padding) * 100}%`,
                                width: `${Math.min(1, line.boundingBox.width + 2 * padding) * 100}%`,
                                height: `${Math.min(1, line.boundingBox.height + 2 * padding) * 100}%`,
                              }}
                            />
                          );
                        })}
                      </div>
                    );
                  })}
                </Document>
              ) : (
                <div className="flex items-center justify-center h-full text-gray-500">
                  No se pudo cargar el archivo
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="flex justify-between items-center mt-6">
        <div className="flex items-center gap-2">
          {processedFileData?.reviewedBy && (
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-green-100 text-green-700 text-sm font-medium">
              ✓ Revisado por {processedFileData.reviewedBy}
              {processedFileData?.reviewedAt && (
                <span className="text-green-600 ml-1">
                  el {new Date(processedFileData.reviewedAt.seconds * 1000).toLocaleDateString("es-MX")}
                </span>
              )}
            </span>
          )}
        </div>
        <div className="flex items-center gap-3">
          {linkId && onMarkAsReviewed && onUnmarkAsReviewed && (
            <Button
              color={processedFileData?.reviewedBy ? "red" : "green"}
              onClick={async () => {
                if (processedFileData?.reviewedBy) {
                  await onUnmarkAsReviewed(linkId, processedFileData.id);
                } else {
                  await onMarkAsReviewed(linkId, processedFileData.id);
                }
                if (onRefresh) {
                  await onRefresh();
                }
                onClose();
              }}
            >
              {processedFileData?.reviewedBy ? "Marcar como NO REVISADO" : "Marcar como revisado"}
            </Button>
          )}
          <Button color="white" onClick={onClose}>
            Cerrar
          </Button>
        </div>
      </div>
    </Dialog>
  );
} 